import Grid from "@afa-shared/afa-components/dist/Grid";
import Heading from "@afa-shared/afa-components/dist/Heading";
import Text from "@afa-shared/afa-components/dist/Text";
import IvHeroImage from "@components/Medias/Image/IvHeroImage";
import { StandardLink } from "@components/StandardLink";

import { HeroBlockType } from "../../types/HeroBlock";
import heroBlockStyles from "./HeroBlock.module.css";

interface IHeroProps {
  heroBlock: HeroBlockType;
}

const HeroBlock = ({ heroBlock }: IHeroProps) => {
  return (
    <div className={heroBlockStyles.heroBlock} id={"innehall"}>
      <Grid className={heroBlockStyles.grid} container alignItems={"center"} margin={"0 auto"}>
        <div className={heroBlockStyles.contentWrapper}>
          <div className={heroBlockStyles.headingWrapper}>
            <Heading
              variant="h1"
              children={heroBlock?.heading}
              removeMargin
              className={heroBlockStyles.heading}
              data-contentful-entry-id={heroBlock?.contentfulPreviewEntryId}
              data-contentful-field-id="heading"
            />
            {heroBlock?.ingress && (
              <Text
                variant={"preamble"}
                children={heroBlock?.ingress}
                removeMargin
                className={heroBlockStyles.text}
                data-contentful-entry-id={heroBlock?.contentfulPreviewEntryId}
                data-contentful-field-id="preamble"
              />
            )}
          </div>
          <div className={heroBlockStyles.list}>
            {heroBlock?.links?.map((item: any, index: number) => {
              const { link } = item;
              return (
                <StandardLink
                  key={index}
                  url={link?.url}
                  text={link?.linkText}
                  type="arrow_forward"
                />
              );
            })}
          </div>
        </div>
        <div className={heroBlockStyles.heroImageWrapper}>
          <IvHeroImage
            image={heroBlock?.image?.imageBlock?.ivImage?.[0]}
            className={heroBlockStyles.ivHeroImage}
            contentfulPreviewEntryId={heroBlock?.image?.imageBlock?.sys?.id}
            contentfulPreviewImageFieldId={"ivImage"}
          />
        </div>
      </Grid>
    </div>
  );
};
export default HeroBlock;
